import React from "react";
import Slider from "react-slick";

import { useAudioPlayer } from "../context/audio-player-context";
import SongSliderItem from "./songs/song-slider-item";

type Props = {
  songs: Songs;
  isLoading: boolean;
};

const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 8000,
  slidesToShow: 1,
  slidesToScroll: 1
};

const WhatsNewSlider: React.FC<Props> = props => {
  const { setCurrentSong, setSongs } = useAudioPlayer();

  const songs = props.songs || [];

  const playSong = (song: Song, index: number) => {
    setCurrentSong(song);
    setSongs(songs, index);
  };

  return (
    <Slider {...settings}>
      {songs.map((song, index) => (
        <div className="px-3" key={song.id}>
          <SongSliderItem song={song} play={playSong} index={index} />
        </div>
      ))}

      {props.isLoading &&
        Array.from(Array(5).keys()).map(id => (
          <div className="w-full px-3" key={id}>
            <div className="w-full pb-1 bg-gray-300 h-44 sm:h-56 rounded-xl animate-pulse">
              <div className="flex flex-col justify-end h-full px-4 py-2">
                <div className="flex items-center">
                  <div className="flex-1">
                    <p className="h-3 pr-4 bg-gray-400 rounded-lg animate-pulse" />
                    <p className="h-2 mt-2 bg-gray-400 rounded-lg animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </Slider>
  );
};

export default WhatsNewSlider;
